export const getValidCenter = (customCenter, center, location) => {
  if (
    customCenter &&
    typeof customCenter.lat === "number" &&
    typeof customCenter.lng === "number"
  ) {
    return customCenter;
  }

  if (
    center &&
    typeof center.lat === "number" &&
    typeof center.lng === "number"
  ) {
    return center;
  }

  if (location?.latitude && location?.longitude) {
    return { lat: location.latitude, lng: location.longitude };
  }

  return { lat: 22.862299, lng: 77.604459 };
};

export const createDefaultPolygon = (lat, lng, offset = 0.0006) => [
  { lat: lat + offset, lng: lng + offset },
  { lat: lat + offset, lng: lng - offset },
  { lat: lat - offset, lng: lng - offset },
  { lat: lat - offset, lng: lng + offset },
];

export const calculatePolygonCenter = (polygon) => {
  if (!polygon || polygon.length === 0) return null;

  const latSum = polygon.reduce((sum, point) => sum + point.lat, 0);
  const lngSum = polygon.reduce((sum, point) => sum + point.lng, 0);

  return {
    lat: latSum / polygon.length,
    lng: lngSum / polygon.length,
  };
};

export const DEFAULT_LOCATION = { latitude: 22.862299, longitude: 77.604459 };

export const GEOLOCATION_OPTIONS = {
  enableHighAccuracy: true,
  maximumAge: 30000,
  timeout: 15000,
};
